<template>
  <v-app>
    <div v-if="editedItem">
      <v-card>
        <v-layout row wrap>
          <v-flex xs5>
            <v-card-title class="headline">系統進件</v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout v-if="isAdmin || isManager || isStaff || isAccounting">
            <v-radio-group v-model="platform" row>
              <v-radio label="裕富案件" value="0"></v-radio>
              <v-radio label="嘉好案件" value="4"></v-radio>
              <v-radio label="21世紀" value="5"></v-radio>
            </v-radio-group>
          </v-layout>
          <v-layout v-if="platform === 4 || platform === '4' && (isAdmin || isManager || isStaff || isAccounting)">
            <v-flex xs6>
              <v-select :items="tags"
                        item-text="name"
                        item-value="name"
                        v-model="tag"
                        label="嘉好案件類別"
                        outline
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select :items="projectList"
                        item-text="name"
                        item-value="name"
                        v-model="project"
                        label="專案"
                        outline
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout v-if="isAdmin || isManager || isStaff || isAccounting">
            <v-flex xs6 v-if="platform === 4 || platform === '4'">
              <v-textarea label="備註">{{editedItem.memo}}</v-textarea>
            </v-flex>
          </v-layout>

          <!--21世紀-->
          <v-layout v-if="platform === 5 || platform === '5' && (isAdmin || isManager || isStaff || isAccounting)">
            <v-flex xs6>
              <v-select :items="tags21"
                        item-text="name"
                        item-value="name"
                        v-model="tag"
                        label="案件類別"
                        outline
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="platform === 0 || platform === '0'">
            <v-flex xs6>
              <v-select :items="caseTypeList"
                        item-text="text"
                        item-value="value"
                        v-model="officialItem.busType"
                        label="業務別"
                        outline
                        @change="setProductStatus"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select :items="promotionList"
                        item-text="text"
                        item-value="key"
                        v-model="officialItem.promotionId"
                        label="專案"
                        outline
              ></v-select>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap v-if="platform === 0 || platform === '0'">
            <v-flex xs6>
              <v-select :items="productCategoryList"
                        item-text="text"
                        item-value="key"
                        v-model="officialItem.productCategoryId"
                        label="商品品牌"
                        outline
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select :items="productIdList"
                        item-text="text"
                        item-value="key"
                        v-model="officialItem.productId"
                        label="商品名稱"
                        outline
              ></v-select>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap>
              <v-flex px-2 xs3>
                <v-text-field
                  v-model="editedItem.header.caseType5" @click="showCheckDialog(0)"
                  :label="'超優'" ></v-text-field>
              </v-flex>
              <v-flex px-2 xs3>
                <v-text-field
                  v-model="editedItem.header.caseType" @click="showCheckDialog(0)"
                  :label="'優加'"></v-text-field>
              </v-flex>
<!--              <v-flex px-2 xs3 v-if="officialItem.busType === 'CA20'">-->
<!--                <v-text-field v-model="editedItem.header.caseType5"  :disabled="checkType5" label="超優" @click="showCheckDialog(2)" readonly></v-text-field>-->
<!--              </v-flex>-->
              <v-flex px-2 xs3>
                <v-text-field
                  v-model="editedItem.header.caseType4" :label="`優質`" @click="showCheckDialog(1)" readonly></v-text-field>
              </v-flex>
<!--              <v-flex px-2 xs3>-->
<!--                <v-checkbox v-model="editedItem.header.type[1].value" :disabled="checkType1" label="一般"></v-checkbox>-->
<!--              </v-flex>-->

          </v-layout>
          <v-layout>
            <v-flex xs12 md6>
              <span>申請日期</span>
              <date-time-tool
                :date-info="editedItem.applyDate"
                :background-color="`#49bcfd`"
                @handleDateChange="applyDateChange"></date-time-tool>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-card>
            <v-layout row wrap>
              <h2>基本資料</h2>
            </v-layout>
            <v-layout row wrap>
              <v-flex pt-4 xs2>
                <v-text-field
                  v-model="editedItem.customer.name"
                  :label="`中文姓名`"
                  background-color='#49bcfd'
                  placeholder="1.必填" outline></v-text-field>
              </v-flex>
              <v-flex pt-4 xs2>
                <v-text-field
                  v-model="editedItem.customer.memberId"
                  :label="`身分證字號`"
                  placeholder="2.必填"
                  background-color='#49bcfd'
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex ml-2 xs5>
                <span>出生日期</span>
                <date-time-tool
                  :date-info="editedItem.customer.birthdayInfo"
                  :background-color="`#49bcfd`"
                  @handleDateChange="customerDateChange"></date-time-tool>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs4>
                    <v-checkbox v-model="editedItem.customer.memberIdType[0].value" label="初發"></v-checkbox>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox v-model="editedItem.customer.memberIdType[1].value" label="補發"></v-checkbox>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox v-model="editedItem.customer.memberIdType[2].value" label="換發"></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <date-time-tool
                      :date-info="editedItem.customer.memberIdDateInfo"
                      :background-color="`#49bcfd`"
                      @handleDateChange="memberIdDateChange"></date-time-tool>
                    <!-- <v-text-field
                      v-model="editedItem.customer.memberIdDate"
                      label="身分證初補換"
                      placeholder="4.必填"
                    ></v-text-field> -->
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-select v-model="editedItem.customer.memberIdCity"
                    item-text="value"
                    item-value="key"
                  :items="getMemberIdCityList" label="發證地點"></v-select>
                <!-- <v-text-field
                  v-model="editedItem.customer.memberIdCity"
                  label="發證地點"
                  placeholder="5.必填"
                ></v-text-field> -->
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-checkbox
                      v-model="editedItem.customer.hasCellphone"
                      :checked="editedItem.customer.hasCellphone"
                      label="無"
                      outline
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs10>
                    <v-text-field
                      v-model="editedItem.customer.cellphone"
                      :disabled="editedItem.customer.hasCellphone"
                      label="行動電話"
                      placeholder="8.必填"
                      background-color='#49bcfd'
                      outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs1 ml-2>
                <v-text-field
                  v-model="editedItem.customer.home.residencePost"
                  label="郵遞區號"
                  type="number"
                  onKeyUp="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"
                  onchange="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"
                ></v-text-field>
              </v-flex>
              <v-flex xs2 ml-1>
                <v-text-field
                  v-model="editedItem.customer.home.residenceCity"
                  label="縣市"
                  placeholder="9.必填"
                  onKeyUp="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                  onchange="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                ></v-text-field>
              </v-flex>
              <v-flex xs2 ml-1>
                <v-text-field
                  v-model="editedItem.customer.home.residenceArea"
                  label="區鄉鎮"
                  placeholder="9.必填"
                  onKeyUp="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                  onchange="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                ></v-text-field>
              </v-flex>
              <v-flex xs7 ml-2>
                <v-text-field
                  v-model="editedItem.customer.home.residenceAddress"
                  label="戶籍地址"
                  placeholder="9.必填"
                  onKeyUp="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                  onchange="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs1>
                <v-checkbox v-model="editedItem.customer.home.homeType1[0].value" label="同戶籍" @change="checkHomeType"></v-checkbox>
              </v-flex>
              <v-flex xs1 ml-2>
                <v-text-field
                  v-model="editedItem.customer.home.homePost"
                  label="郵遞區號"
                  type="number"
                  onKeyUp="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"
                  onchange="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"
                ></v-text-field>
              </v-flex>
              <v-flex xs2 ml-1>
                <v-text-field
                  v-model="editedItem.customer.home.homeCity"
                  label="縣市"
                  placeholder="10.必填"
                  onKeyUp="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                  onchange="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                ></v-text-field>
              </v-flex>
              <v-flex xs2 ml-1>
                <v-text-field
                  v-model="editedItem.customer.home.homeArea"
                  label="區鄉鎮"
                  placeholder="10.必填"
                  onKeyUp="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                  onchange="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 ml-1>
                <v-text-field
                  v-model="editedItem.customer.home.homeAddress1"
                  label="住宅地址"
                  placeholder="10.必填"
                  onKeyUp="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                  onchange="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <!--
            <v-layout>
              <v-flex xs6>
                <v-layout>
                  <v-flex xs4>
                    <div>居住時間</div>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field v-model="editedItem.customer.home.liveYear" label="年"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field v-model="editedItem.customer.home.liveMonth" label="月"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout row wrap>
                  <div>居住狀況</div>
                </v-layout>
                <v-layout row wrap>
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="editedItem.customer.home.liveLevel[0].value"
                        class="mx-2"
                        label="本人名下"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="editedItem.customer.home.liveLevel[1].value"
                        class="mx-2"
                        label="配偶名下"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="editedItem.customer.home.liveLevel[2].value"
                        class="mx-2"
                        label="親友"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="editedItem.customer.home.liveLevel[3].value"
                        class="mx-2"
                        label="租賃"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="editedItem.customer.home.liveLevel[4].value"
                        class="mx-2"
                        label="宿舍"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="editedItem.customer.home.liveLevel[5].value"
                        class="mx-2"
                        label="其他"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-layout>
                <v-flex xs2>
                  <div>繳款方式</div>
                </v-flex>
                <v-flex xs5>
                  <v-checkbox v-model="editedItem.customer.usePhonePayment" label="簡訊條碼繳款"></v-checkbox>
                </v-flex>
                <v-flex xs5>
                  <v-checkbox
                    v-model="editedItem.customer.useElectronicBill"
                    :checked="editedItem.customer.useElectronicBill"
                    label="電子帳單(請填E-mail)"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-text-field
                  v-model="editedItem.customer.paymentEmail"
                  :disabled="!editedItem.customer.useElectronicBill"
                ></v-text-field>
              </v-layout>
            </v-layout>
            <v-layout>
              <v-flex xs2>
                <v-checkbox
                  v-model="editedItem.customer.hasMail"
                  :checked="editedItem.customer.hasMail"
                  label="無"
                ></v-checkbox>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  v-model="editedItem.customer.email"
                  :disabled="editedItem.customer.hasMail"
                  label="E-mail"
                  placeholder="11.填寫加分"
                ></v-text-field>
              </v-flex>
            </v-layout> -->
          </v-card>
          <v-card>
            <v-layout row wrap class="shrink ma-4">
              <h2>職業資料</h2>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap>
                  <div>公司名稱</div>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-checkbox v-model="editedItem.company.type[0].value" label="無"></v-checkbox>
                  </v-flex>

                  <v-flex xs2>
                    <v-checkbox v-model="editedItem.company.type[1].value" label="家管"></v-checkbox>
                  </v-flex>

                  <v-flex xs8>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-checkbox
                          v-model="editedItem.company.type[2].value"
                          :checked="editedItem.company.type[2].value"
                          label="另外如下"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs8>
                        <v-text-field
                          v-model="editedItem.company.name"
                          placeholder="公司名稱必填"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-text-field
                      v-model="editedItem.company.areaCode"
                      label="區碼"
                      placeholder="必填"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      v-model="editedItem.company.phone"
                      label="公司電話"
                      placeholder="必填"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox v-model="editedItem.company.isSecret" label="保密"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6>
                <v-layout row wrap>
<!--                  <v-flex xs2>-->
<!--                    <v-checkbox-->
<!--                      v-model="editedItem.company.hasAddress"-->
<!--                      :checked="editedItem.company.hasAddress"-->
<!--                      label="無"-->
<!--                    ></v-checkbox>-->
<!--                  </v-flex>-->
                  <v-flex xs10>
                    <v-text-field
                      v-model="editedItem.company.address"
                      label="公司地址"
                      placeholder="必填"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs4>
                <v-text-field v-model="editedItem.company.title" label="職稱" placeholder="15.填寫加分"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-layout row wrap>
                  <v-flex xs2>
                    <div>年資</div>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field v-model="editedItem.company.workYear" label="年"></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field v-model="editedItem.company.workMonth" label="月"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs4>
                <v-layout row wrap>
                  <v-flex xs10>
                    <v-text-field
                      v-model="editedItem.company.salary"
                      label="月薪"
                      placeholder="16.填寫加分"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <div class="shrink mr-2 mt-0">元</div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
<!--          <v-card>-->
<!--            <v-layout row wrap class="shrink ma-4">-->
<!--              <v-flex xs12>-->
<!--                <h2>銀行資料</h2>-->
<!--              </v-flex>-->
<!--            </v-layout>-->

<!--            <v-layout row wrap class="shrink ma-4">-->
<!--              <v-flex xs2>-->
<!--                <v-checkbox v-model="editedItem.bank.type[0].value" label="沒辦過卡"></v-checkbox>-->
<!--              </v-flex>-->
<!--              <v-flex xs2>-->
<!--                <v-checkbox v-model="editedItem.bank.type[1].value" label="無卡自停"></v-checkbox>-->
<!--              </v-flex>-->
<!--              <v-flex xs2>-->
<!--                <v-checkbox v-model="editedItem.bank.type[2].value" label="協商繳款中"></v-checkbox>-->
<!--              </v-flex>-->
<!--              <v-flex xs2>-->
<!--                <v-checkbox-->
<!--                  v-model="editedItem.bank.type[3].value"-->
<!--                  :checked="editedItem.bank.type[3].values"-->
<!--                  label="其他："-->
<!--                ></v-checkbox>-->
<!--              </v-flex>-->
<!--              <v-flex xs4>-->
<!--                <v-text-field-->
<!--                  v-model="editedItem.bank.otherType"-->
<!--                  :disabled="!editedItem.bank.type[3].value"-->
<!--                ></v-text-field>-->
<!--              </v-flex>-->
<!--            </v-layout>-->
<!--            <v-layout row wrap>-->
<!--              <v-flex xs6>-->
<!--                <v-text-field placeholder="17.填寫加分" v-model="editedItem.bank.name" label="發卡銀行"></v-text-field>-->
<!--              </v-flex>-->
<!--              <v-flex xs6>-->
<!--                <v-layout row wrap>-->
<!--                  <v-flex xs2>-->
<!--                    <div>有效日期</div>-->
<!--                  </v-flex>-->
<!--                  <v-flex xs5>-->
<!--                    <v-text-field v-model="editedItem.bank.effectiveMonth" label="月"></v-text-field>-->
<!--                  </v-flex>-->
<!--                  <v-flex xs5>-->
<!--                    <v-text-field v-model="editedItem.bank.effectiveYear" label="年"></v-text-field>-->
<!--                  </v-flex>-->
<!--                </v-layout>-->
<!--              </v-flex>-->
<!--            </v-layout>-->
<!--            <v-layout row wrap>-->
<!--              <v-flex xs8>-->
<!--                <v-text-field placeholder="18.填寫加分" label="卡號" v-model="editedItem.bank.creditCard"></v-text-field>-->
<!--              </v-flex>-->
<!--              <v-flex xs4>(請填寫本人正卡資料)</v-flex>-->
<!--            </v-layout>-->
<!--          </v-card> -->
          <v-card>
            <v-layout row wrap class="shrink ma-4">
              <v-flex xs3>
                <!-- <h2>聯絡人資料</h2> -->
              </v-flex>
              <v-flex xs9>
                <!-- <div>(請留一位與您不同居所的親屬，若無住家電話請留兩位聯絡人)</div> -->
              </v-flex>
            </v-layout>
            <!-- <v-layout row wrap>
              <v-flex xs4>
                <v-text-field placeholder="19.必填" label="中文姓名" v-model="editedItem.firstContact.name"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field placeholder="20.必填" label="關係" v-model="editedItem.firstContact.type"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-checkbox
                      v-model="editedItem.firstContact.hasCellphone"
                      :checked="editedItem.firstContact.hasCellphone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs10>
                    <v-text-field
                      v-model="editedItem.firstContact.cellphone"
                      :disabled="editedItem.firstContact.hasCellphone"
                      label="行動電話"
                      placeholder="21.必填"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-checkbox
                      v-model="editedItem.firstContact.hasHomePhone"
                      :checked="editedItem.firstContact.hasHomePhone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs10>
                    <v-text-field
                      v-model="editedItem.firstContact.homePhone"
                      :disabled="editedItem.firstContact.hasHomePhone"
                      label="住宅電話"
                      placeholder="22.填寫加分"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-checkbox
                      v-model="editedItem.firstContact.hasCompanyPhone"
                      :checked="editedItem.firstContact.hasCompanyPhone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      v-model="editedItem.firstContact.companyPhone"
                      :disabled="editedItem.firstContact.hasCompanyPhone"
                      label="公司電話"
                      placeholder="23.填寫加分"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox v-model="editedItem.firstContact.isSecret" label="保密"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs4>
                <v-text-field
                  placeholder="24.必填"
                  label="中文姓名"
                  v-model="editedItem.secondContact.name"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field placeholder="25.必填" label="關係" v-model="editedItem.secondContact.type"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-checkbox
                      v-model="editedItem.secondContact.hasCellphone"
                      :checked="editedItem.secondContact.hasCellphone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs10>
                    <v-text-field
                      v-model="editedItem.secondContact.cellphone"
                      :disabled="editedItem.secondContact.hasCellphone"
                      label="行動電話"
                      placeholder="26.必填"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-checkbox
                      v-model="editedItem.secondContact.hasHomePhone"
                      :checked="editedItem.secondContact.hasHomePhone"
                      label="無"
                      class="shrink mr-2 mt-0"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs10>
                    <v-text-field
                      v-model="editedItem.secondContact.homePhone"
                      :disabled="editedItem.secondContact.hasHomePhone"
                      label="住宅電話"
                      placeholder="27.填寫加分"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-checkbox
                      v-model="editedItem.secondContact.hasCompanyPhone"
                      :checked="editedItem.secondContact.hasCompanyPhone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      v-model="editedItem.secondContact.companyPhone"
                      :disabled="editedItem.secondContact.hasCompanyPhone"
                      label="公司電話"
                      placeholder="28.填寫加分"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox v-model="editedItem.secondContact.isSecret" label="保密"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout> -->

            <v-layout row wrap>※以下欄位資料為：</v-layout>
            <v-layout row wrap>
              <v-flex xs3>
                <v-checkbox
                  v-model="editedItem.hasJointGuarantor[0].value"
                  label="1.連帶保證人(需附保證人身分證正反面影本及簽名)"
                ></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="editedItem.hasJointGuarantor[1].value" label="2.配偶資料僅供參考"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="editedItem.hasJointGuarantor[2].value" label="3.法定代理人(須於法代欄位簽名)"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="editedItem.hasJointGuarantor[3].value" label="4.商品實際使用人"></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex pt-4 xs2>
                <v-text-field v-model="editedItem.jointGuarantor.name"
                              background-color='#ea4f90'
                              outline
                              label="姓名"></v-text-field>
              </v-flex>
              <v-flex pt-4 xs2>
                <v-text-field v-model="editedItem.jointGuarantor.type"
                              background-color='#ea4f90'
                              outline
                              label="關係"></v-text-field>
              </v-flex>
              <v-flex pt-4 xs2>
                <v-text-field v-model="editedItem.jointGuarantor.memberId"
                              background-color='#ea4f90'
                              outline
                              label="身分證字號"></v-text-field>
              </v-flex>
              <v-flex ml-2 xs5 >
                <span>出生日期</span>
                <date-time-tool
                  :date-info="editedItem.jointGuarantor.birthdayInfo"
                  :background-color="`#ea4f90`"
                  @handleDateChange="jointGuarantorDateChange"></date-time-tool>
                <!-- <v-text-field v-model="editedItem.jointGuarantor.birthday"
                @click="showDateToolDialog('jointGuarantor.birthday')" label="生日"></v-text-field> -->
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs3>
                <v-layout row wrap>
                  <v-flex xs4>
                    <v-checkbox v-model="editedItem.jointGuarantor.memberIdType[0].value" label="初發"></v-checkbox>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox v-model="editedItem.jointGuarantor.memberIdType[1].value" label="補發"></v-checkbox>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox v-model="editedItem.jointGuarantor.memberIdType[2].value" label="換發"></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field v-model="editedItem.jointGuarantor.memberIdDate"
                                  background-color='#ea4f90'
                                  outline
                                  label="身分證初補換"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3>
                <v-select v-model="editedItem.jointGuarantor.memberIdCity"
                    item-text="value"
                    item-value="key"
                  :items="getMemberIdCityList" label="發證地點"></v-select>
                <!-- <v-text-field v-model="editedItem.jointGuarantor.memberIdCity"
                              background-color='#ea4f90'
                              outline
                              label="發證地點"></v-text-field> -->
              </v-flex>
              <v-flex xs3>
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="editedItem.jointGuarantor.hasHomePhone"
                      :checked="editedItem.jointGuarantor.hasHomePhone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.homePhone"
                      :disabled="editedItem.jointGuarantor.hasHomePhone"
                      outline
                      label="住家電話"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3>
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="editedItem.jointGuarantor.hasCellphone"
                      :checked="editedItem.jointGuarantor.hasCellphone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.cellphone"
                      :disabled="editedItem.jointGuarantor.hasCellphone"
                      outline
                      label="行動電話"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-text-field v-model="editedItem.jointGuarantor.companyName"
                              background-color='#ea4f90'
                              outline
                              label="公司名稱"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="editedItem.jointGuarantor.hasTitle"
                      :checked="editedItem.jointGuarantor.hasTitle"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.title"
                      :disabled="editedItem.jointGuarantor.hasTitle"
                      outline
                      label="職稱"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>
            <v-layout>
              <v-flex>
                <v-layout row wrap>
                  <!-- <v-flex xs3>
                    <v-checkbox
                      v-model="editedItem.jointGuarantor.hasCompanyPhone"
                      :checked="editedItem.jointGuarantor.hasCompanyPhone"
                      label="無"
                    ></v-checkbox>
                  </v-flex> -->
                  <v-flex xs2>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.companyTelCode"
                      label="區碼"
                      placeholder="必填"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.companyPhone"
                      :disabled="editedItem.jointGuarantor.hasCompanyPhone"
                      outline
                      label="公司電話"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs3>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.companySubPhone"
                      :disabled="editedItem.jointGuarantor.hasCompanyPhone"
                      outline
                      label="分機"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card>
            <v-layout row wrap>
              <h2>經銷商填寫欄</h2>
            </v-layout>
            <v-layout>
              <h3>分期內容</h3>
            </v-layout>
            <v-layout>
              <v-flex xs3>
                <v-text-field
                  v-model="editedItem.vendor.totalPrice"
                  v-if="canCustomPrice"
                  label="商品總價"
                ></v-text-field>
                <v-select
                  v-else
                  v-model="editedItem.vendor.totalPrice"
                  @change="changeInstallmentsNumber"
                  :items="getCreditPriceList"
                  label="商品總價"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs4>
                <v-text-field
                  v-model="editedItem.vendor.installmentsNumber"
                  v-if="canCustomPrice"
                  label="期數"
                ></v-text-field>
                <v-select
                  v-else
                  v-model="editedItem.vendor.installmentsNumber"
                  @change="changeInstallmentsNumber"
                  :items="getInstallmentsNumberList"
                  label="期數"
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-text-field v-model="editedItem.vendor.creditPriceMonth" label="每期應繳金額(期付款)"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="editedItem.vendor.totalCreditPrice"
                  v-if="canCustomPrice"
                  label="分期總額(期數X期付金額)"
                ></v-text-field>
                <span v-else>{{editedItem.vendor.totalCreditPrice}}</span>
              </v-flex>
            </v-layout>
            <v-layout v-if="isAdmin || isStaff || isAccounting">
              <v-flex xs12>
                <v-text-field
                  v-model="officialItem.commission_target" :label="`撥佣對象`"
                  placeholder="統編/身分證號"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card>

          <v-layout mt-2 row wrap>
            <v-flex xs6>
              <v-text-field
                outline
                v-model="officialItem.contactName" :label="`經辦姓名`"
                placeholder="輸入經辦姓名"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                outline
                v-model="officialItem.contactPhone" :label="`經辦電話`"
                placeholder="輸入經辦電話"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-checkbox v-model="checkInputAssignor" label="自行輸入讓與人"></v-checkbox>
          </v-layout>

          <v-layout mt-2 row wrap>
            <v-flex xs6>
              <v-text-field m-1 v-if="checkInputAssignor"
                            v-model="officialItem.assignor" :label="`讓與人`"
                            placeholder="輸入讓與人姓名"></v-text-field>
              <v-autocomplete v-else :items="assignorList"
                              item-text="name"
                              item-value="assignorId"
                              v-model="selectAssignorId"
                              :label="`選擇讓與人`"
                              :loading="loadingAssignorData"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                outline
                v-model="officialItem.assignor_idno" :label="`讓與人ID`"
                placeholder="輸入讓與人ID"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout mt-2 row wrap v-if="platform === 0 || platform === '0'">
            <v-flex xs6>
              <v-text-field
                outline
                v-model="officialItem.dealerBranchNo" :label="`據點代號`"
                placeholder="輸入據點代號"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                outline
                v-model="officialItem.dealerBranchName" :label="`據點名稱`"
                placeholder="輸入據點名稱"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout mt-2 row wrap v-if="platform === 4 || platform === '4'">
<!--            <v-flex xs6>-->
<!--              <v-text-field-->
<!--                outline-->
<!--                v-model="officialItem.dealerBranchNo" :label="`據點代號`"-->
<!--                placeholder="輸入據點代號"></v-text-field>-->
<!--            </v-flex>-->
            <v-flex xs6>
              <v-autocomplete :items="getAgentList"
                              item-text="displayName"
                              item-value="agentId"
                              v-model="officialItem.dealerBranchNo"
                              :label="`據點名稱`"
                              outline
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>
          <v-layout>
            <v-flex>
              <v-btn class="success" dark text @click="searchBankInfo">全台銀行代碼及分行表</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete :items="getBankInfo"
                              item-text="branch"
                              item-value="key"
                              v-model="officialItem.bankId"
                              :label="`撥款銀行代碼`"
                              outline
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :items="getBankSubInfo"
                              item-text="branch"
                              item-value="code"
                              v-model="officialItem.bankSubId"
                              label="撥款銀行分行代碼"
                              outline
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="officialItem.bankAccount" :label="`撥款帳號`"
                outline
                placeholder="輸入正確的帳號"></v-text-field>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>
          <v-layout>
            <v-flex>
              <v-checkbox
                v-model="zipUpload"
                :checked="zipUpload"
                label="上傳手動壓縮的檔案"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout>
          <span class="subheading">
            <span class="red--text">(*)</span>附加檔案 （可傳圖片、PDF、Zip檔案）
          </span>
          </v-layout>
          <upload-view :item-detail="editedItem"
                       :show-upload-button="false"
                       :zip-upload="zipUpload"
                       :is-official="true" @confirmOfficeImages="confirmImages"
                       @onRemoveFile="onRemoveFile"></upload-view>

          <v-card v-if="(editedItem.fileList && editedItem.fileList.length)
          || (hasAttachmentFile)">
            <div class="pb-2 mb-2">
              <v-card-title>
                <span class="title">PDF檔 / Zip檔</span>
              </v-card-title>
              <v-layout ml-2 v-for="(file, i) in editedItem.fileList" :key="i">
                <v-flex ml-2>
                  <a class="subheading" :href="file.data" target="_blank">
                    {{file.imageName}}
                  </a></v-flex>
              </v-layout>
              <v-layout v-if="hasAttachmentFile" ml-2
                        v-for="(file, i) in attachmentFile.attachmentFiles" :key="i">
                <v-flex ml-2>
                  <a class="subheading" :href="file.url" target="_blank">
                    {{file.fileName}}
                  </a></v-flex>
                <v-flex>
                  <v-btn color="error" @click="removeAttachmentFile(i)">刪除</v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span class="mr-2 subheading red--text" v-if="saveLoading">案件上傳中 請勿關閉視窗</span>
          <v-btn class="primary" dark text :loading="saveLoading" @click="checkLastConfirm">確認上傳</v-btn>
        </v-card-actions>
      </v-card>
    </div>

    <v-dialog
      v-model="checkDialog.visible"
      :width="width">
      <v-card>
        <v-card-title class="headline">
          {{checkDialog.text}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout justify-end row>
            <v-btn color="primary" dark text @click="checkDialog.confirm">確定</v-btn>
          </v-layout>
          <v-checkbox class="title" v-model="editedItem.isWork8month" :label="'正職是否滿8個月'"></v-checkbox>
          <hr class="mb-2">
          <v-layout v-for="(item, i) in getRequireCheckList" :key="item.key">
            <v-flex xs12>
              <span class="title">{{item.title}}</span>
              <v-checkbox class="title" v-model="requireOption[i].value" :label="item.text"></v-checkbox>
            </v-flex>
          </v-layout>
          <hr>
          <v-layout row wrap v-for="item in getCheckList" :key="item.key">
            <v-flex xs12>
              <span class="title">{{item.title}}</span>
              <v-checkbox class="title" v-if="requireOption[0].value === true && item.key === 6" :label="item.text" disabled></v-checkbox>
              <v-checkbox class="title" v-else-if="requireOption[1].value === true && item.key === 3" :label="item.text" disabled></v-checkbox>
              <v-checkbox class="title" v-else-if="editedItem.vendor.productId === '1' && item.key === 8" :label="item.text" disabled></v-checkbox>
              <v-checkbox class="title" v-else-if="editedItem.vendor.productId === '2' && item.key === 9" :label="item.text" disabled></v-checkbox>
              <v-checkbox class="title" v-else v-model="item.value" :label="item.text"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark text @click="checkDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.content"
                :show-cancel="messageDialog.showCancel"
                :isHtmlContent="messageDialog.isHtmlContent"
                @confirmEvent="messageDialog.confirm"
                @cancelEvent="messageDialog.cancel"></alert-view>
  </v-app>
</template>

<script>
import UploadView from "../../components/UploadView";
import { getNow, getCreditLoanFiles } from "@/pages/utils/tool";
import MobileDetect from "mobile-detect";
import dateTimeTool from "@/components/dateTimeTool";
import DrawCanvas from "@/components/DrawCanvas";
import { mapActions, mapGetters } from "vuex";
import AlertView from "../../components/AlertView";
import ApplicationModel from '../../models/ApplicationModel';
import AttachmentModel from '../../models/AttachmentModel';
import productIdData from '../../assets/productIdList';
const bankCodeList = require('../../assets/bank_data.json');
const md = new MobileDetect(window.navigator.userAgent);
import { getZipFile, getZipFileByName } from '@/pages/utils/zip';
import common from '@/mixins/common';

export default {
  name: "EditInstallmentProductFrom",
  props: {
    // itemDetail: Object,
    loading: Boolean,
    loadingText: String,
    isSaveSuccess: Boolean,
    cellphone: String,
    visible: Boolean
  },
  components: { dateTimeTool, DrawCanvas, UploadView, AlertView },
  data() {
    return {
      checkInputAssignor: false,
      loadingAssignorData: false,
      selectAssignorId: '',
      assignorList: [],
      requireOption:[{
        value: false,
      },
        {
          value: false,
        }],
      platform: '0',
      defaultCommissionTarget: '83657214', // 預設撥佣對象
      defaultDealerBranchNo: '0001', // 預設據點代號
      defaultDealerBranchName: '嘉好企業有限公司', // 預設據點名稱
      width: md.phone() ? "100%" : "70%",
      uploadType: "add",
      itemDetail:{},
      officialItem: {},
      firstTipCount: 0,
      secondTipCount: 0,
      photoDialog: {
        title: "",
        text: "",
        visible: false,
        loading: false,
        message: "",
        confirm: () => {},
        cancel: () => {}
      },
      signDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      cityInfoDialog: {
        key: "",
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      priceData: require('../../assets/finance_bonus_AA21'),
      creditPriceData: require("../../assets/credit_price"),
      cityData: require("../../assets/taiwan_city"),
      cityList: [],
      areaList: {},
      valid: true,
      dialog: false,
      editedIndex: -1,
      editedItem: null,
      defaultItem: new ApplicationModel(),
      messageDialog: {
        title: "",
        content: "",
        visible: false,
        showCancel: false,
        isHtmlContent: false,
        confirm: () => {},
        cancel: () => {}
      },
      items: [],
      signKey: "customer",
      attachmentFile: {
        attachmentFiles: []
      },
      saveLoading: false,
      defaultItemOfficeItem : {
        tab:'1',
        caseId: '',
        busType: '',
        promotionId: '',
        productCategoryId: '',
        productId: '',
        contactName: '',
        contactPhone: '',
        bankId: '',
        bankSubId: '',
        bankAccount: '',
        attachmentFiles: [],
        telCode: '',
        telPhone: '',
        telExt: '',
        companyCode: '',
        companyPhone: '',
        companyExt: '',
        guarantorTelCode: '',
        guarantorTelPhone: '',
        guarantorTelExt: '',
        guarantorCompanyCode: '',
        guarantorCompanyPhone: '',
        guarantorCompanyExt: '',
        firstContactCode: '',
        firstContactPhone: '',
        firstContactExt: '',
        firstContactCompanyCode: '',
        firstContactCompanyPhone: '',
        firstContactCompanyExt: '',
        secondContactCode: '',
        secondContactPhone: '',
        secondContactExt: '',
        secondContactCompanyCode: '',
        secondContactCompanyPhone: '',
        secondContactCompanyExt: '',
        commission_target: '',
        dealerBranchNo: '',
        dealerBranchName: '',
        assignor:'',
        assignor_idno: '',
      },
      zipUpload: false,
      checkDialog: {
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      tag:'',
      tags:[],
      tags21: [{ key: '商品原融', name: '商品原融'}], // 21世紀
      project:'',
      projectList: [],
    };
  },
  watch:{
    'officialItem.dealerBranchNo'(value){
      const find = this.getAgentList.find(agent=>agent.agentId === value);
      if (find){
        this.officialItem.dealerBranchName = find.displayName;
      }
    },
    platform(value){
      if (value === '4'){
        this.officialItem.busType = 'CC21';
        this.officialItem.promotionId = 'CC220';
      }
      if (value === '5'){
        this.officialItem.busType = 'C21';
        this.officialItem.promotionId = 'C021';
      }
      console.log(`change platform ${value} | ${this.officialItem.promotionId}`)
    },
    selectAssignorId(value){
      console.log(`change selectAssignorId = ${value}`);
      const find = this.assignorList.find(a=>a.assignorId === value);
      if (find){
        this.officialItem.assignor = find.name;
        this.officialItem.assignor_idno = find.memberId;
        console.log(`assignor = ${this.officialItem.assignor}`);
        console.log(`assignor_idno = ${this.officialItem.assignor_idno}`);
      }
    },
    'officialItem.assignor'(value){
      console.log(`set assignor = ${this.officialItem.assignor}`);
    },
    'officialItem.assignor_idno'(value){
      console.log(`set assignor_idno = ${this.officialItem.assignor}`);
    }
  },
  mixins:[common],
  created() {
    this.officialItem = Object.assign({}, this.defaultItemOfficeItem);

    // 自動帶入經辦人資訊
    this.fetchAgentList().then(results=>{
      const current = results.find(u=>u.agentId === this.getUserInfo.agentId);
      if (current) {
        this.officialItem.contactName = current.dealerContactName ? current.dealerContactName: current.financeName;
        this.officialItem.contactPhone = current.dealerContactPhone ? current.dealerContactPhone: current.financePhone;
        this.officialItem.commission_target = current.commissionTarget ? current.commissionTarget : this.defaultCommissionTarget;
        this.officialItem.dealerBranchNo = current.dealerBranchNo ? current.dealerBranchNo : this.defaultDealerBranchNo
        this.officialItem.dealerBranchName = current.dealerBranchName ? current.dealerBranchName : this.defaultDealerBranchName
      }
    });

    this.editedIndex = this.$route.query.editIndex;
    this.platform = this.$route.query.platform ? `${this.$route.query.platform}` : '0';
    console.log(
      `Edit this.editedIndex  == ${this.editedIndex} / ${this.cellphone}`
    );

    this.loadCategoryData();
    this.loadProjectData();
    this.loadAssignorData();

    if (this.editedIndex === 0 || this.editedIndex === "0") {
      // 編輯
      const caseId = this.$route.query.caseId;
      console.log(`Edit Credit caseId == ${caseId}`);

      this.editedItem = Object.assign(this.defaultItem);
      this.fetchCreditProductInfo({ caseId: this.$route.query.caseId }).then(
        async results => {
          if (results.length === 0) {
            // 重複
            this.showMessageDialog(
              "錯誤",
              "查無資料",
              false,
              () => {},
              () => {}
            );
          } else {
            this.editedItem = results[0];

            if (this.editedItem.platform === 4 || this.editedItem.platform === '4'){
              this.platform = '4';
            } else if (this.editedItem.platform === 5 || this.editedItem.platform === '5'){
              this.platform = '5';
            }

            this.tag = this.editedItem.tag;
            this.project = this.editedItem.project;
            this.officialItem.dealerBranchNo = this.editedItem.officialItem.dealerBranchNo;

            this.editedItem.applyDate.isRepublic = true;

            this.officialItem.caseId = this.editedItem.caseId;
            if (!this.editedItem.header.type) {
              this.editedItem.header.type = [
                { key: 0, value: false },
                { key: 1, value: false }
              ];
            }
            if (!this.editedItem.vendor.signature) {
              this.editedItem.vendor.signature = "";
            }
            if (!this.editedItem.customer.birthdayInfo) {
              this.$set(this.editedItem.customer, "birthdayInfo", {
                year: "",
                month: "",
                day: "",
                isRepublic: true,
                startCount: 0
              });
            }
            if (!this.editedItem.customer.memberIdDateInfo) {
              this.$set(this.editedItem.customer, "memberIdDateInfo", {
                year: "",
                month: "",
                day: "",
                isRepublic: true,
                startCount: 0
              });
            }
            if (!this.editedItem.signImage0) {
              this.editedItem.signImage0 = null;
            }
            if (!this.editedItem.signImage1) {
              this.editedItem.signImage1 = null;
            }
            if (!this.editedItem.signImage2) {
              this.editedItem.signImage2 = null;
            }
            if (!this.editedItem.signImage3) {
              this.editedItem.signImage3 = null;
            }
            if (!this.editedItem.customer.isSecret) {
              this.$set(this.editedItem.customer, "isSecret", false);
            }
            if (!this.editedItem.company.isSecret) {
              this.$set(this.editedItem.company, "isSecret", false);
            }
            if (!this.editedItem.firstContact.isSecret) {
              this.$set(this.editedItem.firstContact, "isSecret", false);
            }
            if (!this.editedItem.secondContact.isSecret) {
              this.$set(this.editedItem.secondContact, "isSecret", false);
            }
            if (!this.editedItem.vendor.productId) {
              this.$set(this.editedItem.vendor, "productId", "0");
            }
            if (!this.editedItem.carInfo) {
              this.editedItem.carInfo = {
                carId: "",
                name: "",
                memberId: "",
                relationship: [
                  { key: 0, value: false },
                  { key: 1, value: false },
                  { key: 2, value: false },
                  { key: 3, value: false },
                  { key: 4, value: false },
                  { key: 5, value: false },
                  { key: 6, value: false }
                ]
              };
            }
            if(!this.editedItem.officialItem.tab) {
              this.officialItem.tab ='0';
            }
            if(this.editedItem.officialItem.busType) {
              this.officialItem.busType = this.editedItem.officialItem.busType;
            }
            if(this.editedItem.officialItem.bankId) {
              this.officialItem.bankId = this.editedItem.officialItem.bankId;
            }
            if(this.editedItem.officialItem.promotionId) {
              this.officialItem.promotionId = this.editedItem.officialItem.promotionId;
            }
            if(this.editedItem.officialItem.productCategoryId) {
              this.officialItem.productCategoryId = this.editedItem.officialItem.productCategoryId;
            }
            if(this.editedItem.officialItem.productId) {
              this.officialItem.productId = this.editedItem.officialItem.productId;
            }
            if(this.editedItem.officialItem.contactName) {
              this.officialItem.contactName = this.editedItem.officialItem.contactName;
            }
            if(this.editedItem.officialItem.contactPhone) {
              this.officialItem.contactPhone = this.editedItem.officialItem.contactPhone;
            }
            if(this.editedItem.officialItem.bankId) {
              this.officialItem.bankId = this.editedItem.officialItem.bankId;
            }
            if(this.editedItem.officialItem.bankSubId) {
              this.officialItem.bankSubId = this.editedItem.officialItem.bankSubId;
            }
            if(this.editedItem.officialItem.bankAccount) {
              this.officialItem.bankAccount = this.editedItem.officialItem.bankAccount;
            }
          }

          const result = await this.getFinanceOfficialData({
            caseId: this.editedItem.caseId
          });
          if (result) {
            this.attachmentFile = result;
            console.log(
              `attachmentFile ${JSON.stringify(this.attachmentFile)}`
            );
          }
          const creditLoanFiles = getCreditLoanFiles(this.editedItem)
          if(creditLoanFiles.length > 0) {
            creditLoanFiles.forEach(item => {
              this.attachmentFile.attachmentFiles.push(item)
            })
          }
        }
      );
    } else {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.caseId = Math.uuidFast();
      this.editedItem.displayId = "";
      this.editedItem.category = parseInt(this.$route.query.caseCategory);
      this.editedItem.customer.cellphone = this.cellphone;
      this.editedItem.customer.usePhonePayment = true;

      this.officialItem.caseId = this.editedItem.caseId;

      const now = new Date();
      this.defaultItem.applyDate.isRepublic = true;
      this.defaultItem.applyDate.year = `${now.getFullYear() - 1911}`;
      this.defaultItem.applyDate.month = `${
        now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1
      }`;
      this.defaultItem.applyDate.day = `${
        now.getDate() + 1 < 10 ? `0${now.getDate()}` : now.getDate()
      }`;

      this.editedItem.vendor.productId = "0";
      this.editedItem.vendor.productName = "原車";

      if (this.platform === 4 || this.platform === '4'){ // 嘉好案件
        this.officialItem.busType = 'CC21';
        this.officialItem.promotionId = 'CC220';
      }

      if (this.platform === 5 || this.platform === '5'){ // 21世紀案件
        this.officialItem.busType = 'C21';
        this.officialItem.promotionId = 'C021';
      }

    }
    if (this.getAgentInfo) {
      if (this.getAgentInfo.enableFinanceAgent) {
        this.editedItem.vendor.salesCellphone = this.getAgentInfo.financePhone;
        this.editedItem.vendor.signature = this.getAgentInfo.financeName;
      }
    }
  },
  computed: {
    ...mapGetters([
      "getUserInfo",
      "getAgentList",
      "getCreditItem",
      "getAgentInfo"
    ]),
    hasAttachmentFile() {
      return this.attachmentFile.attachmentFiles.length > 0;
    },
    canCustomPrice() {
      if (
        this.getAgentInfo.canCustomPrice === true ||
        this.isAdmin || this.isAccounting
      ) {
        return true;
      }
      return false;
    },
    isEnableFinanceAgent() {
      if (this.getAgentInfo) {
        if (this.getAgentInfo.enableFinanceAgent) {
          this.editedItem.vendor.salesCellphone = this.getAgentInfo.financePhone;
          this.editedItem.vendor.signature = this.getAgentInfo.financeName;
        }
        return this.getAgentInfo.enableFinanceAgent;
      }
      return false;
    },
    getCreditPriceList() {
      const list = [];
      let end = 350000;
      // 機車原融、借新還舊最高十五萬  7/4開放至20萬
      // if (this.editedItem.vendor.productId === "0") {
      //   end = 150000;
      // }
      for (let i = 30000; i <= end; i += 10000) {
        list.push(i);
      }
      return list;
    },
    getInstallmentsNumberList() {
      // if (this.isAdmin) {
      //   return [12, 15, 18, 20, 24, 30, 36, 48, 50];
      // }
      // 機車原融 50期
      if (this.editedItem.vendor.productId === "0") {
        if (this.editedItem.header.type[1].value === true){ //一般件30期
          return [12, 15, 18, 20, 24, 30, 36, 48, 50];
        }
        return [12, 15, 18, 20, 24, 30, 36, 48, 50];
      }
      if (this.editedItem.vendor.productId === "2") { //他行代償24期
        return [12, 15, 18, 20, 24, 30, 36, 48, 50];
      }
      return [12, 15, 18, 20, 24, 30, 36, 48, 50];
    },
    getVendorType() {
      if (this.editedItem.vendor.productId) {
        return this.editedItem.vendor.productId;
      }
      return 0;
    },
    caseTypeList(){
      if (this.platform === '4'){
        const list = this.getCaseTypeList;
        list.push({ key:'CC21', text: '嘉好自有件' })
        return list;
      }
      return this.getCaseTypeList;
    },
    promotionList() {
      const list = this.getFinanceCaseList;
      if (this.itemDetail.category === 2){
        return this.getCAFinanceCaseList;
      }
      return list.filter(m=> m.busType === this.officialItem.busType);
    },
    getBankInfo(){
      let bankCopyList= JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`
        bankInfo.key = key;
        if (bankInfo.child.length > 0){
          list.push(bankInfo);
        }
      });
      return list;
    },
    getBankSubInfo(){
      let list = [];
      let bankInfo = bankCodeList[this.officialItem.bankId];

      if (bankInfo){
        bankInfo.child.forEach(info=>{
          let copyItemInfo = {};
          Object.assign(copyItemInfo,info);
          copyItemInfo.branch = `(${info.code})${info.branch}`
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    },
    productCategoryList() {
      console.log(`this.officialItem.busType === ${this.officialItem.busType}`)
      let list = this.getProductCategoryList;
      if (this.officialItem.busType === 'CA20'){
        list = this.getProductCategoryList.filter(m=> m.busType === this.officialItem.busType && m.key === 'commodity');
      }
      return list.filter(m=> m.busType === this.officialItem.busType);
    },
    productIdList() {
      return productIdData.list.filter(m=> m.busType === this.officialItem.busType && m.categoryId === this.officialItem.productCategoryId);
    },
    yearList() {
      const startCount = this.dateInfo.startCount === 0 ? this.dateInfo.startCount : 10;
      const start = this.dateInfo.onlyOneYear ?
        new Date().getFullYear() + 3 : new Date().getFullYear() + startCount;
      const end = this.dateInfo.onlyOneYear ?
        new Date().getFullYear() - 3 : 1911;

      const list = [];
      for (let i = start; i >= end; i -= 1) {
        if (this.dateInfo.isRepublic) {
          list.push({ key: `${i - 1911}`, name: `${i - 1911}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    },
    monthList() {
      return [
        { name: '01', key: '01' },
        { name: '02', key: '02' },
        { name: '03', key: '03' },
        { name: '04', key: '04' },
        { name: '05', key: '05' },
        { name: '06', key: '06' },
        { name: '07', key: '07' },
        { name: '08', key: '08' },
        { name: '09', key: '09' },
        { name: '10', key: '10' },
        { name: '11', key: '11' },
        { name: '12', key: '12' },
      ];
    },
    dayList() {
      const startIndex = 1;
      const list = [];
      for (let i = startIndex; i <= 31; i += 1) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    },
    checkCaseType(){
      return (!!this.editedItem.header.caseType4 || !!this.editedItem.header.caseType5 || this.editedItem.header.type[1].value)
    },
    checkCaseType4(){
      return (!!this.editedItem.header.caseType || !!this.editedItem.header.caseType5 || this.editedItem.header.type[1].value)
    },
    checkType1() {
      return (!!this.editedItem.header.caseType4  || !!this.editedItem.header.caseType5 || !!this.editedItem.header.caseType);
    },
    checkType5() {
      return (!!this.editedItem.header.caseType || !!this.editedItem.header.caseType4 || this.editedItem.header.type[1].value);
    },
  },
  methods: {
    ...mapActions([
      "fetchAgentList",
      "fetchCreditProductInfo",
      "getFinanceOfficialData",
      'saveToFinanceOfficial',
      'saveFinanceOfficialData',
      'saveFinanceCreditData',
      'uploadImageData',
      'fetchAgentList',
      'saveFinanceInfo',
      'loadCCHCategorySetting',
      'loadCCHProjects',
      'getAssignorList'
    ]),
    removeAttachmentFile(i){
      this.attachmentFile.attachmentFiles.splice(i, 1);
    },
    async loadProjectData() {
      const res = await this.loadCCHProjects({ category: 'project'});
      const result = res.data;
      this.projectList = result.data;
      console.log(`loadProjectData = ${JSON.stringify(result)}`);
    },
    async loadCategoryData(){
      const res = await this.loadCCHProjects({ category: 'category'});
      const result = res.data;
      this.tags = result.data;
      console.log(`tags = ${JSON.stringify(result)}`);
    },
    confirmImages(files) {
      console.log(`confirmImages == ${files.length}`);
      this.officialItem.attachmentFiles = files;
    },
    onRemoveFile(files){
      console.log(`remove files == ${files.length}`);
      this.officialItem.attachmentFiles = files;
    },
    checkHomeType() {
      if (this.editedItem.customer.home.homeType1[0].value) {
        this.editedItem.customer.home.homePost = this.editedItem.customer.home.residencePost;
        this.editedItem.customer.home.homeCity = this.editedItem.customer.home.residenceCity;
        this.editedItem.customer.home.homeArea = this.editedItem.customer.home.residenceArea;
        this.editedItem.customer.home.homeAddress1 = this.editedItem.customer.home.residenceAddress;
      } else {
        this.editedItem.customer.home.homePost = '';
        this.editedItem.customer.home.homeCity = '';
        this.editedItem.customer.home.homeArea = '';
        this.editedItem.customer.home.homeAddress1 = "";
      }
    },
    showSignDialog(key) {
      this.signKey = key;
      this.signDialog.visible = true;
    },
    changeInstallmentsNumber() {
      const find = this.priceData["0"][this.editedItem.vendor.installmentsNumber][0];
      // const key = `${this.editedItem.vendor.totalPrice}-${this.editedItem.vendor.installmentsNumber}`;
      // const find = this.creditPriceData[key];
      if (find) {
        // console.log(`${parseInt(this.editedItem.creditPriceMonth)} / ${parseInt(find.price)}`);
        const price = find.monthPrice * (this.editedItem.vendor.totalPrice / 10000)

        this.editedItem.vendor.creditPriceMonth = parseInt(price);
        this.editedItem.vendor.totalCreditPrice =
          parseInt(this.editedItem.vendor.installmentsNumber) *
          parseInt(this.editedItem.vendor.creditPriceMonth);
        // console.log(`${JSON.stringify(this.editedItem)}`);
      }
    },
    checkFormData() {
      this.editedItem.customer.home.residencePost = this.editedItem.customer.home.residencePost.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceCity = this.editedItem.customer.home.residenceCity.replace(/([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceArea = this.editedItem.customer.home.residenceArea.replace(/([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceAddress = this.editedItem.customer.home.residenceAddress.replace(/([\r\n])|(<\/?. ?>)/g,'')

      this.editedItem.customer.home.homePost = this.editedItem.customer.home.homePost.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeCity = this.editedItem.customer.home.homeCity.replace(/([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeArea = this.editedItem.customer.home.homeArea.replace(/([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeAddress1 = this.editedItem.customer.home.homeAddress1.replace(/([\r\n])|(<\/?. ?>)/g,'')

      console.log(`officialItem.busType ${this.officialItem.busType}`)
      if (this.platform === 0 || this.platform === '0'){
        if(!this.editedItem.header.caseType &&
          !this.editedItem.header.caseType4 &&
          !this.editedItem.header.caseType5 &&
          !this.editedItem.header.type[1].value) {
          this.showMessageDialog(
            "錯誤",
            "請選擇優加、優質、一般其中一項！",
            false,
            () => {},
            () => {}
          );
          return false;
        }


        if (this.officialItem.busType === "") {
          this.showMessageDialog(
            "錯誤",
            "請選擇業務類別！",
            false,
            () => {},
            () => {}
          );
          return false;
        }
        if (this.officialItem.promotionId === "") {
          this.showMessageDialog(
            "錯誤",
            "請選擇專案！",
            false,
            () => {},
            () => {}
          );
          return false;
        }
        if (this.officialItem.assignor === '' || this.officialItem.assignor_idno === '') {
          this.showMessageDialog(
            "錯誤",
            "請輸入讓與人姓名及身分證",
            false,
            () => {},
            () => {}
          );
          return false;
        }

        if (this.officialItem.productCategoryId === "") {
          this.showMessageDialog(
            "錯誤",
            "請選擇品牌！",
            false,
            () => {},
            () => {}
          );
          return false;
        }
        if (this.officialItem.productId === "") {
          this.showMessageDialog(
            "錯誤",
            "請選擇商品名稱！",
            false,
            () => {},
            () => {}
          );
          return false;
        }
      }

      if (this.platform === 4 || this.platform === '4'){
        if (this.tag === "") {
          this.showMessageDialog(
            "錯誤",
            "請選擇嘉好類別！",
            false,
            () => {},
            () => {}
          );
          return false;
        }
        if (this.project === "") {
          this.showMessageDialog(
            "錯誤",
            "請選擇嘉好專案！",
            false,
            () => {},
            () => {}
          );
          return false;
        }
      }

      if (this.editedItem.customer.memberId === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫身分證！",
          false,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.editedItem.customer.birthday === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫生日！",
          false,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.editedItem.customer.memberIdDate === '') {
        this.showMessageDialog('錯誤', '請填寫身分證初補換日！', false, () => {
        }, () => {
        });
        return false;
      }
      if (!this.editedItem.customer.memberIdType[0].value && !this.editedItem.customer.memberIdType[1].value && !this.editedItem.customer.memberIdType[2].value ) {
        this.showMessageDialog('錯誤', '請勾選身分證初補換！', false, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.memberIdCity === '' || this.editedItem.customer.memberIdCity <= 0) {
        this.showMessageDialog('錯誤', '請選擇發證地點！', false, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.cellphone === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫行動電話！",
          false,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.editedItem.jointGuarantor.name !== "") {
        let hasCheck = false;
        this.editedItem.hasJointGuarantor.forEach(item => {
          if (item.value === true) {
            hasCheck = true;
          }
        });
        if (!hasCheck) {
          this.showMessageDialog(
            "錯誤",
            "請勾選保證人的選項！",
            false,
            () => {},
            () => {}
          );
          return false;
        }
      }

      if(this.hasAttachmentFile) {
        return true;
      }
      if(this.officialItem.attachmentFiles === undefined || this.officialItem.attachmentFiles.length === 0)
      {
        this.showMessageDialog(
          "錯誤",
          "請選擇檔案附件！",
          false,
          () => {},
          () => {}
        );
        return false;
      }

      return true;
    },
    customerDateChange(dateValue){
      this.editedItem.customer.birthday = dateValue;
    },
    memberIdDateChange(dateValue){
      this.editedItem.customer.memberIdDate = dateValue;
    },
    applyDateChange(dateValue){
      console.log(`applyDateChange = ${dateValue}`);
      if (dateValue && dateValue !== ''){
        const [year, month, day] = dateValue.split('-');
        this.editedItem.applyDate.year = year;
        this.editedItem.applyDate.month = month;
        this.editedItem.applyDate.day = day;
      }
    },

    jointGuarantorDateChange(dateValue){
      this.editedItem.jointGuarantor.birthday = dateValue;
      console.log(JSON.stringify(this.editedItem.jointGuarantor));
    },
    checkLastConfirm() {
      if (this.checkFormData()) {

        const isEdit = this.editedIndex === 0 || this.editedIndex === "0";
        if (isEdit){
          this.saveLoading = true;
          setTimeout(async ()=>{
            await this.save();
          }, 3000);
        } else {
          const promotion = this.promotionList.filter(m=>m.key === this.officialItem.promotionId)
          const message = `該案件專案別 : ${promotion[0].text}<br>分期金額 : ${this.editedItem.vendor.creditPriceMonth}<br>期數 : ${this.editedItem.vendor.installmentsNumber}<br>分期總額 : ${this.editedItem.vendor.totalCreditPrice}<br><br>是否正確？`
          this.showMessageDialog(
            "提示",
            message,
            true,
            () => {
              this.saveLoading = true;
              setTimeout(async ()=>{
                await this.save();
              }, 3000);
            },
            () => {
              console.log(`取消`)
            }
          );
        }
      }
    },
    async save() {
        this.saveLoading = true;
        let files = [];
        // console.log(`fileItem == ${JSON.stringify(this.officialItem.attachmentFiles)}`);
        const copyOfficial = JSON.parse(JSON.stringify(this.officialItem));
        try {
          if (!this.zipUpload){ // 系統壓縮
            // 壓縮檔案
            if (this.officialItem.attachmentFiles.length > 0){
              let name = new Date().getTime();
              if (this.editedItem.displayId !== ''){
                name = this.editedItem.displayId;
              } else if (this.editedItem.customer.memberId !== ''){
                name = this.editedItem.customer.memberId;
              }
              const newZip = await getZipFileByName(this.editedItem.caseId, name, this.officialItem.attachmentFiles);
              const uploadResult = await this.uploadImageData(newZip);
              console.log(`uploadResult == ${JSON.stringify(uploadResult)}`);
              newZip.url = uploadResult;
              let attachmentItem = new AttachmentModel();
              attachmentItem.caseId = newZip.caseId;
              attachmentItem.file_index = 0;
              attachmentItem.file_body_encode = newZip.file;
              attachmentItem.file_size = newZip.file;
              attachmentItem.content_type = 'zip';
              attachmentItem.name = newZip.name;
              //程式壓縮
              this.officialItem.attachmentFiles = [
                attachmentItem
              ];
              delete newZip.image;
              delete newZip.file;
              files.push(newZip);
              const record = Object.assign({} , this.officialItem);
              record.attachmentFiles = files;
              console.log(`saveFinanceOfficialData == ${JSON.stringify(record)}`);
              const error = await this.saveFinanceOfficialData(JSON.parse(JSON.stringify(record))); // 紀錄
              console.log(`saveFinanceOfficialData == ${JSON.stringify(error)}`);
            }

          } else {
            if (copyOfficial.length > 0){
              for (let file of copyOfficial.attachmentFiles) {
                // await this.saveAttachmentFile(file);
                let fileItem = { name: `caseFiles/${this.editedItem.caseId}/${file.name}`,
                  fileName: file.name,
                  caseId: this.editedItem.caseId,
                  image: file.file_body_full, url:'' };
                console.log(`fileItem ==${JSON.stringify(fileItem)}`);
                const uploadResult = await this.uploadImageData(fileItem);
                console.log(`uploadResult == ${JSON.stringify(uploadResult)}`);
                fileItem.url = uploadResult;
                delete fileItem.image;
                files.push(fileItem);
                delete file.name;
                delete file.file_body_full;
              }
              const record = Object.assign({} , this.editedItem);
              record.attachmentFiles = files;
              console.log(`saveFinanceOfficialData == ${JSON.stringify(record)}`);
              const error = await this.saveFinanceOfficialData(JSON.parse(JSON.stringify(record))); // 紀錄
              console.log(`saveFinanceOfficialData == ${JSON.stringify(error)}`);
            }
          }
        } catch (e){
          this.saveLoading = false;
          console.log(`saveCaseInfo ERROR`, e);
          this.showMessageDialog('提示', `系統發生錯誤! 原因：${e}`, false, () => {
          }, () => {
          });
          return;
        }

        this.editedItem.officialItem = this.officialItem;
        if (this.editedItem.officialItem){
          if (this.editedItem.officialItem.busType === 'AA21'){
            this.editedItem.vendor.productId = '0';
            this.editedItem.vendor.productName = "機車原融";
          }
          if (this.editedItem.officialItem.busType === 'AA22'){
            this.editedItem.vendor.productId = '1';
            this.editedItem.vendor.productName = "借新還舊";
          }
          if (this.editedItem.officialItem.busType === 'AA23'){
            this.editedItem.vendor.productId = '2';
            this.editedItem.vendor.productName = "他行代償";
          }
          if (this.editedItem.officialItem.busType === 'CA20'){
            this.editedItem.vendor.productId = '3';
            this.editedItem.vendor.productName = "商品貸";
          }
        }

        this.editedItem.tag = this.tag;
        this.editedItem.project = this.project;
        this.editedItem.platform = this.platform;
        this.editedItem.customer.memberId = this.editedItem.customer.memberId.toUpperCase();
        console.log(`saveToFinanceOfficial req === ${JSON.stringify(this.editedItem)}`);

        const isEdit = this.editedIndex === 0 || this.editedIndex === "0";
        if (!isEdit){
          this.editedItem.parentAgent = {
            agentId: this.getUserInfo.agentId ? this.getUserInfo.agentId : 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2',
            agentNumber: this.getUserInfo.agentNumber ? this.getUserInfo.agentNumber : '000000',
            displayName: this.getUserInfo.displayName ? this.getUserInfo.displayName : '總公司',
            parentAgent: {
              agentId: this.getUserInfo.parentAgent ? this.getUserInfo.parentAgent.agentId : 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2',
              rootAgent: 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2'
            },
            salesName: this.getUserInfo.salesName ? this.getUserInfo.salesName : '總公司',
          };
        }
        //儲存案件 to Firebase
        try {
          const copy = JSON.parse(JSON.stringify(this.editedItem));
          copy.officialItem.attachmentFiles = [];
          console.log(`saveCaseInfo copy=== ${JSON.stringify(copy)}`);

          const saveCaseInfo = await this.saveFinanceCreditData(copy);
          console.log(`saveCaseInfo === ${JSON.stringify(saveCaseInfo)}`);
        } catch (e) {
          this.saveLoading = false;
          console.log(`saveCaseInfo ERROR`, e);
          this.showMessageDialog('提示', `儲存至Firebase發生錯誤! 原因：${e}`, false, () => {
          }, () => {
          });
          return;
        }

        //儲存案件 to 裕富
        try {
          const isEdit = this.editedIndex === 0 || this.editedIndex === "0";
          let resultData;
          if (isEdit) { // 編輯
            resultData = await this.saveFinanceInfo(this.editedItem);
            console.log(`sync save == ${JSON.stringify(resultData.data)}`);
          } else {
            if (this.platform ==='0' || this.platform === 0){
              resultData = await this.saveToFinanceOfficial(this.editedItem); // 進件
              console.log(`saveToFinanceOfficial === ${JSON.stringify(resultData)}`);
            } if (this.platform ==='4' || this.platform === 4 || this.platform ==='5' || this.platform === 5){
              resultData = await this.saveFinanceInfo(this.editedItem);
              console.log(`sync save == ${JSON.stringify(resultData.data)}`);
            } else {
              resultData = {
                data: {
                  statusCode: 0 ,
                  message: '儲存成功'
                }
              }
            }
          }

          const saveResult = resultData.data;
          this.saveLoading = false;

          let message = '';
          if (saveResult && saveResult.statusCode === 0) {
            this.isSuccess = true;
            if (isEdit) {
              message = `${saveResult.message}`;
            } else {
              if (saveResult.data){
                message = `進件成功! 案件編號為：${saveResult.data.examineNo}`;
              } else {
                message = `進件成功!`;
              }
            }
            this.showMessageDialog('提示', message, false, () => {
              if (!isEdit) {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.officialItem = Object.assign({}, this.defaultItemOfficeItem);
              }
            }, () => {
            });
          } else {
            this.saveLoading = false;
            if (saveResult && saveResult.data){
              if (isEdit) {
                message = `${saveResult.message}`;
              } else {
                message = `進件至裕富發生錯誤! 原因：${saveResult.data.msg}`;
              }
              this.showMessageDialog('提示', message, false, () => {
              }, () => {
              });
            } else {
              this.showMessageDialog('提示', `進件發生錯誤! 原因：${JSON.stringify(saveResult)}`, false, () => {
              }, () => {
              });
            }
          }

        } catch (e) {
          this.saveLoading = false;
          this.showMessageDialog('提示', `系統發生未預期的錯誤! 原因：${e}`, false, () => {
          }, () => {
          });
        }
    },
    onFinishUpload(result) {
      console.log(`onFinishUpload === ${JSON.stringify(result)}`);
    },
    showMessageDialog(title, text, isHtmlContent, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.content = text;
      this.messageDialog.showCancel = isHtmlContent
      this.messageDialog.isHtmlContent = isHtmlContent
      this.messageDialog.visible = true;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    dataURLtoBlob(dataUrl) {
      let arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    showTip() {
      if (this.firstTipCount < 1) {
        this.firstTipCount += 1;
        this.showMessageDialog(
          "提示",
          "聯絡人一率保密，僅在逾期繳款才會通知聯絡人",
          false,
          () => {},
          () => {}
        );
        setTimeout(() => {
          this.messageDialog.visible = false;
        }, 2500);
      }
    },
    showSecondTip() {
      if (this.secondTipCount < 1) {
        this.secondTipCount += 1;
        this.showMessageDialog(
          "提示",
          "聯絡人一率保密，僅在逾期繳款才會通知聯絡人",
          false,
          () => {},
          () => {}
        );
        setTimeout(() => {
          this.messageDialog.visible = false;
        }, 2500);
      }
    },
    searchBankInfo(){
      window.open('https://www.banking.gov.tw/ch/home.jsp?id=60&parentpath=0,4&mcustomize=FscSearch_BankType.jsp&type=1',
        '_blank');
    },
    checkRequireOptions(){
      const checkRequireCount = this.requireOption.filter(m=>m.value === true);
      return checkRequireCount.length === 2;
    },
    showCheckDialog(type) {
      console.log(`${this.editedItem.vendor.productId} || ${this.editedItem.vendor.productId}`);
      let typeText = '請選擇優加符合項目';
      if (type === 1){
        typeText = '請選擇優質符合項目'
      } else if (type === 2){
        typeText = '請選擇超優符合項目'
      }

      this.checkDialog.visible = true;
      this.checkDialog.text = typeText;
      this.checkDialog.confirm = () => {
        // console.log(JSON.stringify(this.getCheckList));
        const checkRequireCount = this.requireOption.filter(m=>m.value === true);
        const checkCount = this.getCheckList.filter(m=>m.value === true);
        this.editedItem.header.caseType = ''
        this.editedItem.header.caseType4 = ''
        this.editedItem.header.caseType5 = ''

        let i = 0;
        let requireContent = '';
        for (let option of this.getRequireCheckList){
          if (this.requireOption[i].value){
            requireContent += `${option.option} `;
          }
          i++;
        }
        if (checkRequireCount.length === 0 && checkCount.length === 1){ // 優質專案
          for (let item of this.getCheckList){
            if (item.value) {
              requireContent += `${item.key + 1} `;
            }
          }
          this.editedItem.header.caseType4 += requireContent;
        } else if (checkRequireCount.length === 0 && checkCount.length > 1 && this.getCheckList[0].value === false){ // 優質專案
          for (let item of this.getCheckList){
            if (item.value) {
              requireContent += `${item.key + 1} `;
            }
          }
          this.editedItem.header.caseType4 += requireContent;
        } else if (checkRequireCount.length > 0  || (checkCount.length > 1 && this.getCheckList[0].value === true)){ // 優加專案
          for (let item of this.getCheckList){
            if (item.value) {
              requireContent += `${item.key + 1} `;
            }
          }
          if (checkRequireCount.length > 0){
            this.editedItem.header.caseType5 += requireContent;
          } else {
            this.editedItem.header.caseType += requireContent;
          }
        }
        this.checkDialog.visible = false;
      };
    },
    setProductStatus() {
      if (this.officialItem.busType === 'AA21') {
        this.editedItem.vendor.productId = "0";
        this.editedItem.vendor.productName = "原車";
        this.editedItem.header.caseType4 = ''
      } else if(this.officialItem.busType === 'AA22') {
        this.editedItem.vendor.productId = "1";
        this.editedItem.vendor.productName = "借新";
        this.editedItem.header.caseType4 = ''
      } else if(this.officialItem.busType === 'AA23') {
        this.editedItem.vendor.productId = "2";
        this.editedItem.vendor.productName = "代償";
        this.editedItem.header.caseType = ''
      } else if (this.officialItem.busType === 'CA20'){
        this.editedItem.vendor.productId = '3';
        this.editedItem.vendor.productName = "商品貸";
      }
    },
    async loadAssignorData(){
      try {
        this.loadingAssignorData = true;
        const res = await this.getAssignorList({
          agentId: ''
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          const list = result.data;
          const filter = list.filter(assignor=>assignor.agentId === this.selectAgentId);
          if(filter.length){
            this.assignorList = filter;
          } else {
            this.assignorList = list.filter(assignor=>assignor.memberId==='A126611362');
          }
          console.log(`assignorList ${JSON.stringify(this.assignorList)}`);
        }
      } catch (e) {
        console.log(`loadAssignorData error `, e)
      } finally {
        this.loadingAssignorData = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/web/EditInstallmentProductFrom.vue